import Vue from "vue"
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 导入 Element UI 的语言包
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale' // 导入 locale 模块
// 从 localStorage 读取语言设置
const savedLocale = localStorage.getItem('locale') || 'zh'
const initialLocale = savedLocale === 'zh' ? zhLocale : enLocale

// 配置 Element UI 国际化，使用保存的语言
Vue.use(ElementUI, {
  locale: initialLocale
})
import App from './App.vue'
import router from './router'

import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)

import LazyLoadDirective from '@/utils/lazyload'
Vue.directive('lazyload', LazyLoadDirective)

import { isMobile, getDeviceType } from '@/utils/device'
Vue.prototype.$isMobile = isMobile;
Vue.prototype.$getDeviceType = getDeviceType;

// 防止按钮点击重复触发函数
Vue.directive('preventReClick', {
  inserted (el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 3000)
      }
    })
  }
})

import { i18n } from './i18n/index'

// 正确的 Element UI 语言切换方法
Vue.prototype.$setElementLocale = function(lang) {
  if (lang === 'zh') {
    locale.use(zhLocale)  // 使用 locale.use 而不是重新 Vue.use
  } else {
    locale.use(enLocale)
  }
  // Element UI 会自动更新，不需要 $forceUpdate
}

new Vue({
    el: '#app',
    router,
    i18n,
    render: h => h(App)
})